<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right @show="onShow">
    <template #button-content>
      <feather-icon v-bind:badge="badge" badge-classes="bg-danger" class="text-body" icon="CalendarIcon" size="21"/>
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Events
        </h4>
<!--        <b-badge pill variant="light-primary" v-if="totalOfUnreaded > 0">
          {{totalOfUnreaded}} New
        </b-badge>-->
      </div>
    </li>

    <!-- Events -->
    <li class="scrollable-container media-list scroll-area custom-scrollbar" style="height: 600px; overflow: auto" >
      <!-- Account Event -->
      <b-link v-for="event in events" :key="event.id">
        <b-media>
          <template #aside>
            <b-avatar size="32"  :variant="$t(`calendarTypes.${event.type}.color`)">
              <template #default>
                <i :class="$t(`calendarTypes.${event.type}.symbol`)"/>
              </template>
            </b-avatar>
          </template>
<!--          <span class="float-right text-muted" style="font-size: 10px"> {{event.start | momentDateTime }}</span>-->

          <p class="media-heading">
            <span class="font-weight-bolder">
             {{getEventTitle(event)}}
            </span>
          </p>
          <small class="event-text"> {{event.start | momentDateTime }}</small>
          <br/>

        </b-media>
      </b-link>
      <div v-if="loading" class="text-center">
        <b-spinner>{{ $t('operations.loading') }}</b-spinner>
      </div>
    </li>

  </b-nav-item-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { mapActions, mapGetters } from 'vuex'
import mixinBase from '@/components/mixin/mixinBase'
import mixinTable from '@/components/mixin/mixinTable'
import { vue } from '@/main'

export default {
  name: 'CalendarEventsDropdown',
  components:{VuePerfectScrollbar},
  mixins:[ mixinBase],
  data:()=>({
    badge: '',
    events: [],
    loading: false,
  }),
  computed:{

  },
  methods:{
    ...mapActions('calendar', ['getTodayUpcomingEvents']),
    onShow(){
      this.fetchEvents();
    },
    fetchEvents() {
      let $this = this;
      this.loading = true;
      this.getTodayUpcomingEvents().then(data=>{
        $this.events = data?.sort((a,b)=>{
          return $this.$moment(a.start).unix() - $this.$moment(b.start).unix()
        });
      }).finally(()=>{
        $this.loading = false;
      })
    },
    getEventTitle(event) {
      let title = event.title || null;
      if(event.clientNames != null){
        title = Object.values(event.clientNames)[0]
        title = vue.$t(`calendarTypes.${event.type || 'EVENT'}.name`) + ' - ' + title
      }
      if(title == null || title === ''){
        title = vue.$t(`calendarTypes.${event.type}.name`)
      }
      return title;
    }

  },
}
</script>

<style>

</style>
